import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { Button } from '@digital/ui';
import { aprovar } from '@app/api/RegraSubstituto';

export interface propsButtonAprovar {
    regraId: string;
    updatePage: any;
}

const ButtonAprovar = (props: propsButtonAprovar) => {
    const { regraId, updatePage } = props;

    const handleSubmit = (values: any) => {
        aprovar(regraId).then(data => {
            if (data) {
                updatePage();
            }
        });
    };

    return (
        <>
            <Tooltip title="Aprovar">
                <Button
                    onClick={() => {
                        handleSubmit({ regraId });
                    }}
                    name="btnAprovar"
                    confirm={'Aprovar?'}
                    okText={"Aprovar"}
                    icon="ui-checked"
                />
            </Tooltip>
        </>
    );
};
export default ButtonAprovar; 